import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export const getProfilePictureUrl =
  withNextApi<BackendResponse>(
    "/cvp/CvpGetProfilePicture",
    {
      method: "GET",
    }
  );
